<template>
  <div class="noAboutData">
    <img src="@/assets/images/template/noData.png">
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: 'NoData'
}
</script>
